import IconCalendarDay from './IconCalendarDay';

export default IconCalendarDay;
